<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="TPO: Mous"
                   :links="[{title:'Home', url:'/'},{title:'TPO', url: ''}, {title: 'MOUs'}]"></page-header>
        <div class="container-2">
          <section class="sidebar">
            <sidebar :active="9"></sidebar>
          </section>
          <section class="content">
            <div class="heading-black1">Mous</div>
            <blockquote class="about-message">
              <p>SND College of Engg. & Research Center always
                welcomes all industry allies who search for feasible and practical solution. Together SNDCOE &RC and
                esteemed organization in different domain can make great progress in building awareness, in shaping
                budding engineering leaders. The industry is up to date in the realistic world. The industry- institute
                interaction will help in exchanging the intellectual understanding of faculty, students and the
                practical expertise of industry. Since last two years various MoU are signed to build up association and
                mutual exchange of benefits with industries. </p>
            </blockquote>
            <div class="rounded-lg shadow-lg mt-5 overflow-x-auto">
              <table class="w-full ">
                <thead class="bg-gray-300 ">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name of Organization/ Company</th>
                  <th scope="col"> Purpose /Activities</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">1</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">EvolvingX (OPC) Services Pvt. Ltd. –
                    Pune
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Internship & Development
                    Programme
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">2</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">ACKS Solutions Pvt. Ltd.
                    -Ahemadnagar
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Software Development
                    Seminar/Webinar
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">3</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Civil Tech Pvt. Ltd. Nashik</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Training, Internship,
                    Recruitment
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">4</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Kasnet Technologies Pvt. Ltd.
                    -Pune
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Training, Internship,
                    Recruitment
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">5</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Sofsyst Pvt. Ltd. Nashik</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Training, Internship,
                    Recruitment
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">6</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Sharda Electronics Pvt. Ltd.
                    Sangali
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Training, Internship,
                    Recruitment
                  </td>
                </tr>
                <tr class="bg-white border-b hover:bg-gray-100">
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">7</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Shreeson Pvt. Ltd. Nashik</td>
                  <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Students Training, Internship,
                    Recruitment
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>

        </div>
        <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/tpo/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Mous",
  components: {
    KeyRecruiters,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped/>
